import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import {
    InfoBlock,
    InfoRow,
    InfoCell
} from 'components';
import { useTranslation } from 'react-i18next';

export const TabVesselRouteInfo = ({ bookingDetails = {} }) => {
    const [t] = useTranslation();
    return <InfoBlock
        className="tr__details-box col-sm-3"
        title={t("home.active-shipment.details.tabs.shipment-tab.booking-details")}
    >
          <InfoRow >
            <div className="col-12">
                <div className='row'>
                    <InfoCell
                        className="col-sm-6"
                        label={t("home.active-shipment.details.tabs.shipment-tab.carrier-name")}
                        value={bookingDetails.carrierName ? bookingDetails.carrierName : ''}
                    />
                    <InfoCell
                        className="col-sm-6"
                        label={t("home.active-shipment.details.tabs.shipment-tab.scac-code")}
                        value={bookingDetails.scacCode ? bookingDetails.scacCode : ''}
                    />
                </div>
            </div>
            <div className="col-12 mtx2">
                <div className='row'>
                    <InfoCell
                        className="col-sm-6"
                        label={t("home.active-shipment.details.tabs.shipment-tab.booking-confirmation")}
                        value={bookingDetails.confirmationNo ? bookingDetails.confirmationNo.join(', ') : ''}
                    />
                    <InfoCell
                        className="col-sm-6"
                        label={t("home.active-shipment.details.tabs.shipment-tab.master-bill")}
                        value={bookingDetails.masterBoL ? bookingDetails.masterBoL.join(', ') : ''}
                    />
                </div>
            </div>
            <div className="col-12 mtx2">
                <div className='row'>
                    <InfoCell
                        className="col-sm-6"
                        label={t("home.active-shipment.details.tabs.shipment-tab.house-bill")}
                        value={bookingDetails.houseBoL ? bookingDetails.houseBoL.join(', ') : ''}
                    />
                </div>
            </div>
        </InfoRow>
    </InfoBlock>
};

TabVesselRouteInfo.propTypes = {
    shippingDetails: PropTypes.object,
};